import React from 'react';
import { FiCopy } from 'react-icons/fi';

const PayloadViewer = ({ data, path = 'data' }) => {
  const copyToClipboard = (copyPath) => {
    navigator.clipboard.writeText(`{{${copyPath}}}`);
    alert(`Path copied: {{${copyPath}}}`);
  };

  const renderValue = (key, value, currentPath) => {
    const fullPath = `${currentPath}.${key}`;
    if (typeof value === 'object' && value !== null) {
      return (
        <div key={key} className="ml-4">
          <span className="text-purple-400">"{key}"</span>: <span className="text-gray-400">{Array.isArray(value) ? '[' : '{'}</span>
          {Array.isArray(value) ? (
            value.map((item, index) => renderValue(index, item, fullPath))
          ) : (
            Object.entries(value).map(([k, v]) => renderValue(k, v, fullPath))
          )}
          <span className="text-gray-400">{Array.isArray(value) ? ']' : '}'}</span>
        </div>
      );
    }
    return (
      <div key={key} className="flex items-center ml-4 hover:bg-gray-700 rounded group">
        <span className="text-purple-400">"{key}"</span>: <span className="text-green-400">"{String(value)}"</span>
        <button
          type="button"
          onClick={() => copyToClipboard(fullPath)}
          className="ml-4 text-gray-500 group-hover:text-white opacity-0 group-hover:opacity-100 transition-opacity"
          title={`Copy path: {{${fullPath}}}`}
        >
          <FiCopy />
        </button>
      </div>
    );
  };

  return (
    <div className="bg-gray-800 text-white font-mono text-xs p-4 rounded-md max-h-96 overflow-y-auto">
      <pre>
        <span className="text-gray-400">{'{'}</span>
        {Object.entries(data).map(([key, value]) => renderValue(key, value, 'data'))}
        <span className="text-gray-400">{'}'}</span>
      </pre>
    </div>
  );
};

export default PayloadViewer;